export const URL_STYLE_VAR = {
    '--csc-collect-list-loading': 'udata/pkg/fe/loading.d77acd8b.svg',
    '--csc-collect-video-icon': 'udata/pkg/KS-COLLECT/static/ks-collect/img/video-upload-icon.svg',
    '--csc-collect-spc-image-upload-add': 'udata/pkg/KS-COLLECT/add.d7bc7df8fb86120b.png',
    '--csc-collect-copy-icon': 'udata/pkg/KS-COLLECT/static/ks-collect/img/copy-icon.svg',
    '--csc-collect-ocr-success': 'udata/pkg/KS-COLLECT/ocr-success.svg',
    '--csc-collect-ocr-fail': 'udata/pkg/KS-COLLECT/ocr-fail.svg',
    '--csc-collect-close-icon': 'kos/nlav10901/close.f1a4e72b7d471e2e.png',
    '--csc-collect-ks-logo': 'udata/pkg/KS-COLLECT/ks-logo.png',
    '--csc-collect-right-arrow': 'udata/pkg/KS-COLLECT/static/ks-collect/img/right-arrow.svg',
    '--csc-collect-icon-back': 'kos/nlav10901/static/images/icon-back_3x.png',
};

export function injectAllStyleVar() {
    console.log('[zy] injectAllStyleVar');
    Object.keys(URL_STYLE_VAR).forEach(key => {
        const varKey = key;
        const varValue = `url('${withDynamicCdn(URL_STYLE_VAR[key])}')`;
        if (!document.body.style.getPropertyValue(varKey)) {
            document.body.style.setProperty(varKey, varValue);
        }
    });
}

export function withDynamicCdn(url) {
    const cdnPublic = window.cdn_public || 'h2.static.yximgs.com';
    return `https://${cdnPublic.replace('//', '')}/${url}`;
}